// assets/cart-bundle.js
(function () {
  // ── 1. Al cargar: limpiar bundle duplicado si viene de "Actualizar carrito" ──
  async function replaceBundleIfNeeded() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const targetBundle = cart.attributes && cart.attributes._replaceBundleGroupId;
    const expectedNewPageCount = cart.attributes && cart.attributes._replaceBundleNewPageCount;
    if (!targetBundle) return;

    const bundleLines = cart.items
      .map((item, idx) => ({ ...item, position: idx + 1 }))
      .filter(item => (item.properties || {})._bundleGroupId === targetBundle);

    // Mantener solo la base recién añadida y el último addon de cada tipo
    const keep = new Set();
    const baseLines = bundleLines.filter(l => (l.properties || {})._addon !== 'true');

    // La línea base "nueva" se identifica por su _pageCount (lo informa el
    // editor vía el atributo _replaceBundleNewPageCount), no por su posición
    // en el array: Shopify no garantiza que la línea recién añadida quede en
    // el último índice cuando ya existe una línea base antigua del mismo
    // bundle en el carrito (con otro _pageCount, por tanto otra key).
    let lastBase = null;
    if (expectedNewPageCount) {
      lastBase = baseLines.find(l => (l.properties || {})._pageCount === expectedNewPageCount) || null;
    }
    if (!lastBase) {
      // Fallback: comportamiento anterior (última por posición) — por si el
      // atributo no llega (p.ej. theme desplegado antes que el editor).
      lastBase = [...baseLines].reverse()[0] || null;
    }
    if (lastBase) keep.add(lastBase.position);

    const lastAddonByType = new Map();
    for (const l of bundleLines) {
      if ((l.properties || {})._addon !== 'true') continue;
      const type = (l.properties || {})._addonType || 'unknown';
      if (!lastAddonByType.has(type)) lastAddonByType.set(type, l.position);
    }
    for (const pos of lastAddonByType.values()) keep.add(pos);

    const toRemove = bundleLines
      .map(l => l.position)
      .filter(pos => !keep.has(pos))
      .sort((a, b) => b - a);

    // Shopify fusiona líneas con propiedades idénticas sumando `quantity`
    // (p.ej. al pulsar "Actualizar carrito" sin cambiar nada, la línea base
    // pasa de quantity 1 a 2). La línea base del álbum siempre debe ir con
    // quantity 1 — la cantidad del addon la recalcula reconcileAddonQuantities
    // a partir de `_pageCount`, así que aquí NO la tocamos (forzarla a 1
    // rompería los pedidos con varios bloques de páginas extra).
    const needsBaseFix = lastBase && lastBase.quantity !== 1;

    if (toRemove.length === 0 && !needsBaseFix) {
      await clearReplaceAttribute();
      return;
    }

    for (const position of toRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: position, quantity: 0 }),
      });
    }

    if (needsBaseFix) {
      // /cart/change.js usa el índice de línea ACTUAL (1-based); las líneas
      // ya eliminadas (con posición original menor) desplazan el índice.
      const removedBefore = toRemove.filter(pos => pos < lastBase.position).length;
      const adjustedLine = lastBase.position - removedBefore;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: adjustedLine, quantity: 1 }),
      });
    }

    await clearReplaceAttribute();
    window.location.reload();
  }

  async function clearReplaceAttribute() {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _replaceBundleGroupId: '', _replaceBundleNewPageCount: '' } }),
    });
  }

  // ── 1b. Reconciliar la cantidad del addon de páginas extra ──
  // Shopify fusiona líneas con la misma variante + propiedades sumando la
  // cantidad, así que repetir "Actualizar carrito" infla el addon (5 → 10 → …).
  // WORKAROUND: recalculamos la cantidad correcta desde `_pageCount` (que la
  // línea base ya trae) y forzamos el addon a ese valor en cada carga. Es
  // idempotente: si ya coincide, no hace nada. Cura también carritos ya inflados.
  // TODO: BASE_PAGE_COUNT está fijado aquí de forma temporal; debe venir de la
  // config del producto (Payload/metafield), no hardcodeado.
  const BASE_PAGE_COUNT = 12; // páginas incluidas en el precio base
  const PAGES_PER_BLOCK = 4;  // las páginas extra se venden en bloques de 4

  async function reconcileAddonQuantities() {
    const cart = await fetch('/cart.js').then(r => r.json());

    // Agrupar líneas por bundle
    const bundles = new Map();
    cart.items.forEach(item => {
      const bundleId = (item.properties || {})._bundleGroupId;
      if (!bundleId) return;
      if (!bundles.has(bundleId)) bundles.set(bundleId, []);
      bundles.get(bundleId).push(item);
    });

    const updates = {};
    for (const group of bundles.values()) {
      const base = group.find(l => (l.properties || {})._addon !== 'true');
      // Sin `_pageCount` no podemos calcular: no tocamos esas líneas.
      const raw = base && (base.properties || {})._pageCount;
      if (raw === undefined) continue;
      const pageCount = parseInt(raw, 10);
      if (!Number.isFinite(pageCount)) continue;

      const extraPages = Math.max(0, pageCount - BASE_PAGE_COUNT);
      const expected = Math.ceil(extraPages / PAGES_PER_BLOCK);

      const addons = group.filter(
        l => (l.properties || {})._addon === 'true'
          && (l.properties || {})._addonType === 'extra_pages'
      );
      // Mantener la primera línea de addon en la cantidad correcta; el resto a 0.
      addons.forEach((addon, i) => {
        const target = i === 0 ? expected : 0;
        if (addon.quantity !== target) updates[addon.key] = target;
      });
    }

    if (Object.keys(updates).length === 0) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    window.location.reload();
  }

  // ── 2. Al eliminar un item base, eliminar también sus addons ──
  function hookRemoveButtons() {
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('cart-remove-button');
      if (!btn) return;

      const lineKey = btn.dataset.key; // Dawn pasa el key en data-key
      if (!lineKey) return;

      const cart = await fetch('/cart.js').then(r => r.json());
      const removed = cart.items.find(i => i.key === lineKey);
      if (!removed) return;

      const props = removed.properties || {};
      const bundleId = props._bundleGroupId;
      const isAddon = props._addon === 'true';
      if (!bundleId || isAddon) return; // solo actuar cuando se borra la base

      const siblings = cart.items.filter(
        i => i.properties && i.properties._bundleGroupId === bundleId && i.key !== lineKey
      );
      if (siblings.length === 0) return;

      const updates = {};
      siblings.forEach(s => { updates[s.key] = 0; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      // Dawn recarga el carrito solo tras el click; los siblings ya estarán en 0
    });
  }

  // ── 3. Reordenar filas para que los addons aparezcan siempre debajo de su base ──
  function reorderAddonRows() {
    const tbody = document.querySelector('.cart-items tbody');
    if (!tbody) return;

    tbody.querySelectorAll('tr.cart-item[data-is-addon="true"]').forEach(addonRow => {
      const bundleId = addonRow.dataset.bundleId;
      if (!bundleId) return;
      const baseRow = tbody.querySelector(
        `tr.cart-item[data-bundle-id="${bundleId}"]:not([data-is-addon="true"])`
      );
      if (baseRow && baseRow.nextElementSibling !== addonRow) {
        baseRow.insertAdjacentElement('afterend', addonRow);
      }
    });
  }

  // Re-aplicar el reorden cada vez que Dawn actualiza el carrito vía AJAX
  function observeCartUpdates() {
    const container = document.querySelector('#main-cart-items');
    if (!container) return;

    const observer = new MutationObserver(() => {
      // Desconectar antes de mover nodos para no entrar en bucle
      observer.disconnect();
      reorderAddonRows();
      observer.observe(container, { childList: true, subtree: true });
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  (async function init() {
    // replaceBundleIfNeeded puede recargar la página; si lo hace, el script se
    // reinicia y la reconciliación corre tras la recarga.
    await replaceBundleIfNeeded();
    await reconcileAddonQuantities();
  })();
  hookRemoveButtons();
  reorderAddonRows();
  observeCartUpdates();
})();
